import _ from "lodash";
import React, { useContext, useState } from 'react';
import {
  Alert, Button, Card, CardBody, Col, Container,
  Form, FormGroup, Input, Label, Row
} from 'reactstrap';
import { api, UserContext } from "../utils";

export default function UpdatePassword(props) {
  const userCtx = useContext(UserContext);
  const [message, setMessage] = useState(null);
  const [user, setUser] = useState(userCtx.currentUser);

  function onChange(fieldName, fieldValue) {
    let newUser = Object.assign({}, user);
    newUser[fieldName] = fieldValue;
    setUser(newUser);
  }

  function onUpdatePassword(e) {
    e.preventDefault();

    let warnings = [];
    if (!user.newPassword || _.trim(user.newPassword).length < 8) {
      warnings.push('Please provide a valid, new password of at least 8 characters.')
    }
    if (!user.oldPassword || _.trim(user.oldPassword).length < 8) {
      warnings.push('Please provide a valid, existing password of at least 8 characters.')
    }
    if (!user.newPasswordAgain || _.trim(user.newPasswordAgain).length < 8) {
      warnings.push('Please provide your valid, new password a second time.')
    }
    if (user.newPassword !== user.newPasswordAgain) {
      warnings.push('Your new password and password confirmation do not match.')
    }
    if (user.newPassword === user.oldPassword) {
      warnings.push('Your new password and old password must be different.')
    }
    if (warnings.length) {
      setMessage({
        text: warnings.join(' '),
        flavor: 'alert-danger'
      });
      return;
    } else {
      setMessage(null);
    }
    api.post('User/UpdatePassword', { password: user.newPassword, oldPassword: user.oldPassword }).then(response => {
      if (response.data.success) {
        setMessage({ text: "Your password has been updated successfully! We're now redirecting you to the home screen.", flavor: "alert-success" });
        const newUser = {
          ...user,
          mustChangePassword: false, oldPassword: "", newPassword: "", newPasswordAgain: ""
        };
        setUser(newUser);
        setTimeout(() => userCtx.signIn(newUser), 3000);
      } else {
        setMessage({ text: response?.data?.message, flavor: "alert-danger" });
      }
    }).catch(api.catchHandler);
  }

  return (
    <Container className="mt-5">
      <h4 className="my-4">Your password needs to be updated...</h4>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <Form onSubmit={onUpdatePassword}>
                <FormGroup className="mb-2">
                  <Label for="oldPassword">Old Password</Label>
                  <Input
                    type="password"
                    name="oldPassword"
                    id="oldPassword"
                    onChange={(event) => onChange(event.target.name, event.target.value)}
                    value={user.oldPassword || ""}
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label for="newPassword">New Password</Label>
                  <Input
                    type="password"
                    name="newPassword"
                    id="newPassword"
                    onChange={(event) => onChange(event.target.name, event.target.value)}
                    value={user.newPassword || ""}
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label for="newPasswordAgain">Confirm New Password</Label>
                  <Input
                    type="password"
                    name="newPasswordAgain"
                    id="newPasswordAgain"
                    onChange={(event) => onChange(event.target.name, event.target.value)}
                    value={user.newPasswordAgain || ""}
                  />
                </FormGroup>
                <FormGroup className="text-right">
                  <Button
                    className="shredButton float-end"
                    type="submit"
                  >
                    Update Password
                  </Button>
                </FormGroup>
              </Form>
              {message && <Alert className={`mt-3 ${message.flavor}`}>{message.text}</Alert>}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>);
}
